import React, { useState, useEffect } from "react";
import { Link } from "react-router-dom";
import DataTable from "react-data-table-component";
import { supportService } from "../../services/SupportServices";
import { toast } from "react-toastify";

const SupportTickets = () => {
  const [supportEnquiries, setSupportEnquiries] = useState([]);
  const [statusCounts, setStatusCounts] = useState({});
  const [loading, setLoading] = useState(true);
  const [filterText, setFilterText] = useState("");

  const columns = [
    {
      name: "Ticket ID",
      selector: (row) => row.ticket_id,
      sortable: true,
    },
    {
      name: "Subject",
      selector: (row) => row.subject,
      sortable: true,
    },
    {
      name: "Status",
      cell: (row) => {
        const statusLabels = {
          pending: "warning",
          in_progress: "info",
          on_hold: "danger",
          resolved: "success",
          closed: "secondary",
        };
        const label = statusLabels[row.status] || "secondary";
        return <span className={`badge bg-${label}`}>{row.status.replace("_", " ")}</span>;
      },
      sortable: true,
    },
    {
      name: "Last Update",
      selector: (row) => formatDate(row.updatedAt),
      sortable: true,
    },
    {
      name: "Support",
      selector: () => "John Nichols",
      sortable: false,
    },
    {
      name: "Actions",
      cell: (row) => (
        <>
          <Link to={`/admin/support-ticket/details/${row._id}`} className="btn btn-link btn-sm text-muted" title="View">
            <i className="fa fa-eye"></i>
          </Link>
        </>
      ),
      ignoreRowClick: true,
      allowOverflow: true,
      button: true,
    },
  ];

  const fetchSupportEnquiries = async () => {
    try {
      const response = await supportService.supportTicketList();
      if (response.status === 200 && response.data.success) {
        const tickets = response.data.data || [];
        setSupportEnquiries(tickets);
        calculateStatusCounts(tickets);
      } else {
        toast.error(response.data?.message || "Failed to fetch tickets.");
      }
    } catch (error) {
      toast.error("Failed to fetch support tickets.");
    } finally {
      setLoading(false);
    }
  };


  const calculateStatusCounts = (tickets) => {
    const counts = tickets.reduce((acc, ticket) => {
      acc[ticket.status] = (acc[ticket.status] || 0) + 1;
      return acc;
    }, {});
    setStatusCounts(counts);
  };

  useEffect(() => {
    fetchSupportEnquiries();
  }, []);

  const formatDate = (dateString) => {
    const date = new Date(dateString);
    return date.toLocaleDateString("en-IN");
  };

  const filteredEnquiries = supportEnquiries.filter(
    (enquiry) =>
      enquiry.ticket_id.toLowerCase().includes(filterText.toLowerCase()) ||
      enquiry.subject.toLowerCase().includes(filterText.toLowerCase()) ||
      enquiry.status.toLowerCase().includes(filterText.toLowerCase())
  );

  const statusCards = [
    { label: "New", key: "pending", color: "danger" },
    { label: "In Progress", key: "in_progress", color: "info" },
    { label: "On Hold", key: "on_hold", color: "warning" },
    { label: "Resolved", key: "resolved", color: "success" },
  ];

  return (
    <>
      <div className="body-header border-bottom d-flex py-3">
        <div className="container-xxl">
          <div className="row align-items-center">
            <div className="col">
              <h1 className="h4 mt-1">Support Tickets</h1>
            </div>
          </div>
        </div>
      </div>

      <div className="body d-flex py-3">
        <div className="container-xxl">
          <div className="row g-3">
            <div className="col-12">
              <div className="card overflow-hidden">
                <div className="progress" style={{ height: "4px" }}>
                  {statusCards.map((card) => (
                    <div
                      key={card.key}
                      className={`progress-bar bg-${card.color}`}
                      role="progressbar"
                      style={{ width: `${statusCounts[card.key] || 0}%` }}
                    ></div>
                  ))}
                </div>
                <div className="card-body">
                  <div className="row g-3">
                    {statusCards.map((card) => (
                      <div className="col-md-3 col-sm-6" key={card.key}>
                        <div className="card p-3">
                          <div className="text-muted text-uppercase">
                            <i className={`fa fa-circle me-2 text-${card.color}`}></i>
                            {card.label}
                          </div>
                          <div className="mt-1">
                            <span className="fw-bold h4 mb-0">
                              {statusCounts[card.key] || 0}
                            </span>
                          </div>
                        </div>
                      </div>
                    ))}
                  </div>
                </div>
              </div>
            </div>

            <div className="col-12">
              <div className="mb-3 d-flex justify-content-between">
                <h5 className="mb-0 mt-3">Showing {filteredEnquiries.length} Tickets</h5>
                <input
                  type="text"
                  className="form-control w-25"
                  placeholder="Search tickets..."
                  value={filterText}
                  onChange={(e) => setFilterText(e.target.value)}
                />
              </div>

              <DataTable
                columns={columns}
                data={filteredEnquiries}
                pagination
                highlightOnHover
                progressPending={loading}
                noDataComponent="No support enquiries found."
              />
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default SupportTickets;
